import { FavouriteLayoutTypeContext } from 'app/components/favourite-layout/constants';
import { LayoutAttributes } from './types';

// Tile
export const tileOptions = [
  { description: 'attribute_field_labels', value: LayoutAttributes.fieldLabels },
  { description: 'attribute_quantities', value: LayoutAttributes.quantities },
  { description: 'attribute_groups', value: LayoutAttributes.groups },
  { description: 'attribute_wide_layout', value: LayoutAttributes.wideLayout },
  { description: 'attribute_totals', value: LayoutAttributes.totals }
];
export const tileAttributeMappings = {
  compactView: 'Tile.CompactView',
  hideAggrColumns: 'Tile.HideAggrColumns',
  hideHeader: 'Tile.HideHeader',
  wideLayout: 'Tile.WideLayout',
  hideTotals: 'Tile.HideTotals'
};

// Table
export const tableOptions = [
  { description: 'attribute_field_labels', value: LayoutAttributes.fieldLabels },
  { description: 'attribute_quantities', value: LayoutAttributes.quantities },
  { description: 'attribute_groups', value: LayoutAttributes.groups },
  { description: 'attribute_totals', value: LayoutAttributes.totals },
  { description: 'attribute_suppress_repeating_rows', value: LayoutAttributes.suppressRepeatingRows }
];
export const tableAttributeMappings = {
  suppressRepeatingRows: 'Table.SuppressRepeatingRows',
  compactView: 'Table.CompactView',
  hideAggrColumns: 'Table.HideAggrColumns',
  hideHeader: 'Table.HideHeader',
  hideTotals: 'Table.HideTotals'
};

// Heatmap
export const heatmapOptions = [
  { description: 'attribute_yAxis_labels_enabled', value: LayoutAttributes.yAxisLabelsEnabled },
  { description: 'attribute_xAxis_labels_enabled', value: LayoutAttributes.xAxisLabelsEnabled }
];

export const heatmapAttributeMappings = {
  xAxisLabelsEnabled: 'Highcharts.xAxis.labels.enabled',
  yAxisLabelsEnabled: 'Highcharts.yAxis.labels.enabled'
};

// Pie
export const pieOptions = [
  { description: 'attribute_show_value', value: LayoutAttributes.showValue },
  { description: 'attribute_show_percent', value: LayoutAttributes.showPercent },
  { description: 'attribute_hide_datalabels_on_dashboards',
    value: LayoutAttributes.hideDatalabelsOnDashboards,
    layoutTypeContext: FavouriteLayoutTypeContext.Dashboard
  },
  { description: 'attribute_donut_view', value: LayoutAttributes.donutView },
  { description: 'attribute_semi_circle_view', value: LayoutAttributes.semiCircleView }
];

export const pieAttributeMappings = {
  showValue: 'Pie.ShowValue',
  showPercent: 'Pie.ShowPercent',
  hideDatalabelsOnDashboards: 'Pie.HideDatalabelsOnDashboards',
  donutView: 'Pie.DonutView',
  semiCircleView: 'Pie.SemiCircleView'
};

// Column
export const columnAndBarOptions = [
  { description: 'attribute_stacked', value: LayoutAttributes.stacked },
  { description: 'attribute_percent', value: LayoutAttributes.percent }
];

export const columnAttributeMappings = {
  stacked: 'Column.Stacked',
  percent: 'Column.Percent'
};

// Area
export const areaOptions = [
  { description: 'attribute_stacked', value: LayoutAttributes.stacked },
  { description: 'attribute_percent', value: LayoutAttributes.percent }
];

export const areaAttributeMappings = {
  stacked: 'Area.Stacked',
  percent: 'Area.Percent'
};

// Bar
export const barAttributeMappings = {
  stacked: 'Bar.Stacked',
  percent: 'Bar.Percent'
};

export const chartLayoutAttributes = {
  heatmapType: 'HighchartsStyle.heatmapUseDataPointColors',
  chartType: 'Highcharts.chart.type'
};

export type AttributeMappingType = Partial<typeof tileAttributeMappings & typeof tableAttributeMappings
  & typeof heatmapAttributeMappings & typeof pieAttributeMappings & typeof columnAttributeMappings
  & typeof barAttributeMappings>;

export const MIN_NO_OF_CRITERIAS = 2;
